import React from 'react';

const ServiceCard = ({ service }) => {
  return (
    <div className="group bg-white rounded-2xl overflow-hidden border border-[#E4E1D8] hover:border-[#0F6E56] transition-all duration-300 hover:shadow-xl">
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
        <div className="absolute bottom-4 left-4 right-4">
          <span className="inline-block px-3 py-1 bg-[#0F6E56] text-white text-xs font-semibold rounded-full mb-2">
            {service.code}
          </span>
          <h3 className="text-white font-bold text-lg leading-tight">
            {service.title}
          </h3>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        <span className="text-xs font-semibold text-[#5DCAA5] uppercase tracking-wide">
          {service.category}
        </span>
        <p className="text-[#6B6B69] text-sm leading-relaxed">
          {service.description}
        </p>
      </div>
    </div>
  );
};

export default ServiceCard;